import auth0 from 'auth0-js'
import { audience, clientId, domain } from '../../constants/auth'
import { siteUrl } from '../../constants'

const auth0Client = new auth0.WebAuth({
  domain,
  clientID: clientId,
  audience,
  redirectUri: `${siteUrl}`,
  scope: 'openid profile email',
})

export default auth0Client
